.container
    width: 100vw
    height: 100%
    position: fixed
    z-index: 1000
    top: 0
    left: 0
    overflow: hidden
    iframe
        width: 100%
        height: 100%
